export enum WhatsAppTemplateTypes {
    HANDOUT_EVENT_REMINDER = 'handoutEventReminder',
    SUBSTITUTION_REQUEST = 'substitutionRequest',
    /** Waiting list asked again after the office revoked the confirmation (same placeholders + sLink as SUBSTITUTION_REQUEST) */
    SUBSTITUTION_REQUEST_REOPENED = 'substitutionRequestReopened',
    /** "Vertretung bestätigt": thanks after the confirmation (link or office), same placeholders + sLink as SUBSTITUTION_REQUEST */
    SUBSTITUTION_CONFIRMATION = 'substitutionConfirmation',
    COURSE_CANCELED = 'courseCanceled',
    HANDOUT_EVENT_FEEDBACK_REQUEST = 'handoutEventFeedbackRequest',
    /** Austeilaktion: Terminbestätigung anfragen (Button `<CLIENT_URL>/#/handout-event-confirmation/{{1}}` = Token) */
    HANDOUT_EVENT_CONFIRMATION_REQUEST = 'handoutEventConfirmationRequest',
    TAKEOVER_OFFER = 'takeoverOffer',
    MAKEUP_PRESENCE_DATE = 'makeupPresenceDate',
    MAKEUP_ROUND_INVITATION = 'makeupRoundInvitation',
    MAKEUP_ROUND_CONFIRMATION = 'makeupRoundConfirmation',
    /** QM-Cockpit feedback requests (dynamic URL button `<CLIENT_URL>/#/feedback/{{1}}`) */
    QM_FEEDBACK_CHILD = 'qmFeedbackChild',
    QM_FEEDBACK_TEACHER = 'qmFeedbackTeacher',
    QM_FEEDBACK_INSTITUTION = 'qmFeedbackInstitution',
    /** Rückrufbitte after an unanswered call (Anruf-Fenster); schools have no mobile number → mail only */
    CALLBACK_REQUEST_FAMILY = 'callbackRequestFamily',
    CALLBACK_REQUEST_TEACHER = 'callbackRequestTeacher',
    /** Ereignis-Fälle of the QM-Cockpit (Spec Verbleib Teil 4.1): one template per trigger, by click in the Akte or automatic */
    QM_EVENT_UNEXCUSED = 'qmEventUnexcused',
    QM_EVENT_TEACHER_CHANGE = 'qmEventTeacherChange',
    /** „2× Fortschritt −1“: to the teacher (du) */
    QM_EVENT_PROGRESS = 'qmEventProgress',
}

/** WhatsApp template type of an event case per trigger (QualityRiskEventTrigger value) */
export const QM_EVENT_WHATS_APP_TEMPLATE_TYPES: Record<'unexcusedTwice' | 'teacherChange' | 'progressDrop', WhatsAppTemplateTypes> = {
    unexcusedTwice: WhatsAppTemplateTypes.QM_EVENT_UNEXCUSED,
    teacherChange: WhatsAppTemplateTypes.QM_EVENT_TEACHER_CHANGE,
    progressDrop: WhatsAppTemplateTypes.QM_EVENT_PROGRESS,
};

/** WhatsApp template type of a Rückrufbitte per audience (schools: none) */
export const CALLBACK_REQUEST_WHATS_APP_TEMPLATE_TYPES: Record<'family' | 'teacher', WhatsAppTemplateTypes> = {
    family: WhatsAppTemplateTypes.CALLBACK_REQUEST_FAMILY,
    teacher: WhatsAppTemplateTypes.CALLBACK_REQUEST_TEACHER,
};

/** WhatsApp template type of a QM feedback request per target group (QualityOnboardingTarget value) */
export const QM_FEEDBACK_WHATS_APP_TEMPLATE_TYPES: Record<'child' | 'teacher' | 'institution', WhatsAppTemplateTypes> = {
    child: WhatsAppTemplateTypes.QM_FEEDBACK_CHILD,
    teacher: WhatsAppTemplateTypes.QM_FEEDBACK_TEACHER,
    institution: WhatsAppTemplateTypes.QM_FEEDBACK_INSTITUTION,
};

export const WhatsAppTemplateTypesVue = [
    {
        text: 'Erinnerung Austeilaktion (Werbende)',
        value: WhatsAppTemplateTypes.HANDOUT_EVENT_REMINDER,
    },
    {
        text: 'Vertretungsanfrage (Lehrkraft)',
        value: WhatsAppTemplateTypes.SUBSTITUTION_REQUEST,
    }, {
        text: 'Vertretungsanfrage wieder frei (Lehrkraft)',
        value: WhatsAppTemplateTypes.SUBSTITUTION_REQUEST_REOPENED,
    }, {
        text: 'Vertretung bestätigt (Lehrkraft)',
        value: WhatsAppTemplateTypes.SUBSTITUTION_CONFIRMATION,
    }, {
        text: 'Kursabsage (Elterninfo)',
        value: WhatsAppTemplateTypes.COURSE_CANCELED,
    }, {
        text: 'Feedbackanfrage Austeilaktion (Werbende)',
        value: WhatsAppTemplateTypes.HANDOUT_EVENT_FEEDBACK_REQUEST,
    }, {
        text: 'Terminbestätigung Austeilaktion (Anfrage)',
        value: WhatsAppTemplateTypes.HANDOUT_EVENT_CONFIRMATION_REQUEST,
    }, {
        text: 'Übernahmeangebot (Lehrkraft)',
        value: WhatsAppTemplateTypes.TAKEOVER_OFFER,
    }, {
        text: 'Nachholtermin vor Ort (Elterninfo)',
        value: WhatsAppTemplateTypes.MAKEUP_PRESENCE_DATE,
    }, {
        text: 'Angebot Online-Nachholtermin (Ja-Link, Elterninfo)',
        value: WhatsAppTemplateTypes.MAKEUP_ROUND_INVITATION,
    }, {
        text: 'Online-Nachholtermin bestätigt (Uhrzeit, Zoom, Elterninfo)',
        value: WhatsAppTemplateTypes.MAKEUP_ROUND_CONFIRMATION,
    }, {
        text: 'QM-Feedbackanfrage Eltern',
        value: WhatsAppTemplateTypes.QM_FEEDBACK_CHILD,
    }, {
        text: 'QM-Feedbackanfrage Lehrkraft',
        value: WhatsAppTemplateTypes.QM_FEEDBACK_TEACHER,
    }, {
        text: 'QM-Feedbackanfrage Standort',
        value: WhatsAppTemplateTypes.QM_FEEDBACK_INSTITUTION,
    }, {
        text: 'Rückrufbitte Eltern',
        value: WhatsAppTemplateTypes.CALLBACK_REQUEST_FAMILY,
    }, {
        text: 'Rückrufbitte Lehrkraft',
        value: WhatsAppTemplateTypes.CALLBACK_REQUEST_TEACHER,
    }, {
        text: 'Ereignis-Fall: unentschuldigt gefehlt',
        value: WhatsAppTemplateTypes.QM_EVENT_UNEXCUSED,
    }, {
        text: 'Ereignis-Fall: Lehrerwechsel',
        value: WhatsAppTemplateTypes.QM_EVENT_TEACHER_CHANGE,
    }, {
        text: 'Ereignis-Fall: Fortschritt (Lehrkraft)',
        value: WhatsAppTemplateTypes.QM_EVENT_PROGRESS,
    }];
